/** Anchor of the on-chain section; the authentication seal scrolls to it. */
export const ON_CHAIN_SECTION_ID = 'on-chain'

export function getChainName(chainId) {
  if (Number(chainId) === 80002) return 'Polygon Amoy'
  if (Number(chainId) === 137) return 'Polygon'
  return `Chain ${chainId}`
}

/** Short network qualifier shown next to the Polygon mark. */
export function getNetworkLabel(chainId) {
  if (Number(chainId) === 80002) return 'Amoy testnet'
  if (Number(chainId) === 137) return 'Mainnet'
  return `Chain ${chainId}`
}
